import React from "react";
import RewardsModuleRewards from './RewardsModuleRewards';

export const Rewards = ({ data, getData }) => {
  // Define a consistent gap between grid items
  const gridGap = '10px';

  return (
    <>
      <div style={{
        // display: 'grid',
        // gridTemplateColumns: 'repeat(auto-fit, minmax(125px, 1fr))', // 1fr ensures even distribution of space
        // gap: gridGap, // Use the gap for consistent spacing
        marginTop: '10px',
        marginBottom: '25px',
      }}>
        {/* The DashboardModuleSmartRewards may take up only the space it needs without specifying spans */}
        <RewardsModuleRewards data={data} getData={getData} />

        {/* SmartRewards, UltraFlect, and Variegate can be assumed to take one full row each without explicit row spans if they don't need to span multiple rows */}
        {/* <SmartRewards data={data} getData={getData} /> */}
      </div>
        {/* <Variegate data={data} getData={getData} /> */}
        {/* <Subscriptions data={data} getData={getData} /> */}
      {/* </div> */}
    </>
  );
};

export default Rewards;



// const [activeIndex, setActiveIndex] = useState(0);

// const formatSubMenu = (menuItem) => {
//   return (
//     <div style={{color: 'black'}}>
//           {menuItem}
//     </div>
//   );
// }

// const [protocolValue, setProtocolValue] = useState("Smart Rewards");
// const protocolOptions = ["Smart Rewards","Variegate","Reflect"];



// const data2 = [
//   { 
//       date: 'January 2023', total: 0, smart: 0, varie: 0, fuel: 0,
//   },
//   { 
//       date: 'February 2023', total: 5.25, smart: 2.51, varie: 1.49, fuel: 1.25,
//   },
//   { 
//       date: 'March 2023', total: 14.55, smart: 4.55, varie: 4.55, fuel: 5.45,
//   },
//   { 
//       date: 'April 2023', total: 26.85, smart: 8.91, varie: 9.99, fuel: 7.95,
//   },
//   { 
//       date: 'May 2023', total: 36.55, smart: 12.55, varie: 14.55, fuel: 9.45,
//   },
//   { 
//       date: 'June 2023', total: 47.25, smart: 16.19, varie: 19.11, fuel: 11.95,
//   },
//   ];

//   const [chartWidth, setChartWidth] = useState(0);
// const [chartHeight, setChartHeight] = useState(0);
// const chartContainer = useRef();



// const CustomTooltip = ({ active, payload, label }) => {
//   if (active && payload && payload.length) {
//     return (
//       <div className="custom-tooltip" style={{background: 'rgba(255, 255, 255, 0.85)', paddingTop: '4px', paddingBottom: '8px', paddingLeft: '4px', paddingRight: '4px' ,borderRadius: '10px', fontSize: '12px'}}>
//         <p className="label">{`${label}`}</p>
//         <>{`Total: $${payload[0].payload.total}`}</><br/>
//         <>{`Smart: $${payload[0].payload.smart}`}</><br/>
//         <>{`Varie: $${payload[0].payload.varie}`}</><br/>
//         <>{`Fuel: $${payload[0].payload.fuel}`}</><br/>
//       </div>
//     );
//   }

//   return null;
// }

{/* 
      <Card title={<div style={rewardZoneHeaderStyle}>Reward Zone</div>} style={rewardZoneStyle}>
      <div style={bannerInfoStyle}>
          <TabMenu model={[{label: 'SUMMARY'},{label: 'CONFIGURE'},{label: ""}]} style = {infoStyle}/>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '10px', marginTop: '20px'}}>
              <Card
                title={
                  <div style={cardHeaderStyle}>
                    {tileToggle ? "Reward Protocol" : "Choose a Reward Protocol"}
                    </div>
                }
                style={tileToggle ? getCardStyle(0,1,1) : getCardStyle(0,1,1)}
                onClick={() => {if(tileToggle) setTileToggle(!tileToggle)}}
                onMouseEnter={() => handleMouseEnter(0)}
                onMouseLeave={() => handleMouseLeave(0)}
              >
                <div style={infoStyle}>
                  { tileToggle ? protocolValue : 
                <div className="card flex justify-content-center">
                  <Dropdown value={protocolValue} onChange={(e) => setProtocolValue(e.value)} options={protocolOptions} placeholder="Select a Protocol" className="w-full md:w-14rem" />

                  <Button>Subscribe</Button><br/>
                  <Button onClick={() => {setTileToggle(!tileToggle)}}>Cancel</Button><br/>
                </div>}
                </div>
              </Card>
                
              <Card title={<div style={cardHeaderStyle}>Reward Profile</div>} style={cardStyle}>
              <div style={infoStyle}>
                  <img src={incnIcon} style={{ marginRight: '5px', width: '30px', height: '30px' }}/>
                  <span>INCN</span>
                </div>
              </Card>

              <Card title={<div style={cardHeaderStyle}>Reward Position</div>} style={cardStyle}>
                <div style={infoStyle}>
                  2.05%
                </div>
              </Card>

              <Card title={<div style={cardHeaderStyle}>Top Reward Earned</div>} style={cardStyle}>
                <div style={infoStyle}>
                  <img src={afntyIcon} style={{ marginRight: '5px', width: '30px', height: '30px' }}/>
                  <span>AFNTY</span>
                </div>
              </Card>
                      
              <Card title={<div style={cardHeaderStyle}>Profile Builder</div>} style={rewardSelectionStyle}>
              <div style={infoStyle}>
                  INCN
                </div>
              </Card>
          </div>
        </div>
      </Card>


      <Card title={<div style={communityHeaderStyle}>Leaderboards</div>} style={communityStyle}>
        <div style={bannerInfoStyle}>
          <TabMenu model={[{label: 'COMMUNITY'},{label: "REWARDED"},{label: ""}]} style = {infoStyle}/>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '10px', marginTop: '20px'}}>
            <Card title={<div style={cardHeaderStyle}>Most Subscribed</div>} style={btcbCardStyle}>
              <div style={infoStyle}>
                BTC
              </div>
            </Card>

            <Card title={<div style={cardHeaderStyle}>Most Voted</div>} style={afntyCardStyle}>
              <div style={infoStyle}>
                AFNTY
              </div>
            </Card>

            <Card title={<div style={cardHeaderStyle}>Recently Added</div>} style={incnCardStyle}>
              <div style={infoStyle}>
                INCN
              </div>
            </Card>

            <Card title={<div style={cardHeaderStyle}>Most Engaged</div>} style={sfmCardStyle}>
              <div style={infoStyle}>
                SAFEMOON
              </div>
            </Card>
          </div>
        </div>
      </Card>

      */}

/*
  useEffect(() => {
    function updateSize() {
      setChartWidth(chartContainer.current.offsetWidth);
      setChartHeight(chartContainer.current.offsetHeight);
    }

    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);


<Card title={<div style={bannerHeaderStyle}>Reward Performance Over Time</div>} style={bannerStyle}>
        <div style={bannerInfoStyle}>
          <TabMenu model={[{label: 'LIFETIME'},{label: "90D"},{label: "30D"}]} />
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))', gap: '10px', marginTop: '20px'}}>
            <div>
              <div style={dashletHeaderStyle}>
              Total Earned
              </div>
              <div >
              $47.00
              </div>
            </div>
            <div>
              <div style={dashletHeaderStyle}>
              Smart Rewards
              </div>
              <div >
                $16.19
              </div>
            </div>
            <div>
              <div style={dashletHeaderStyle}>
              Variegate
              </div>
              <div >
                $19.11
              </div>
            </div>
            <div>
              <div style={dashletHeaderStyle}>
              Fuel Rewards
              </div>
              <div >
                $11.95
              </div>
            </div>
          </div>
        </div>
        <div ref={chartContainer} style={{ gridColumn: 'span 2', gridRow: 'span 1', width: '100%', height: '400px' }}>

        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            width={chartWidth}
            height={chartHeight}
            data={data}
            margin={{
              top: 5, right: 15, left: 0, bottom: 5,
            }}
          >
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            <Area type="monotone" dataKey="smart" stackId="1" stroke="#0b5ed7" fill="#0b5ed7" />
            <Area type="monotone" dataKey="varie" stackId="1" stroke="#3b8afd" fill="#3b8afd" />
            <Area type="monotone" dataKey="fuel" stackId="1" stroke="#97c1fe" fill="#97c1fe" />
          </AreaChart>
        </ResponsiveContainer>
        </div>
      </Card>


      */